import { render } from "./EditClientProfile.vue?vue&type=template&id=3a2c5b41&scoped=true"
import script from "./EditClientProfile.vue?vue&type=script&lang=js"
export * from "./EditClientProfile.vue?vue&type=script&lang=js"

import "./EditClientProfile.vue?vue&type=style&index=0&id=3a2c5b41&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a2c5b41"]])

export default __exports__